export default {
  state: {
    // appName: "沿江通道综合监控系统",  // 应用名称
    themePath: "dark",  // 主题路径
    themeColor: "#120d22",  // 主题颜色
    menuBgColor: "#120d22",  // 菜单背景颜色
    menuTextColor: "#fff",  // 菜单文字颜色
    menuTextActiveColor: "#0DBED2",  // 菜单文字激活颜色
    // oldThemeColor: "#053E99",   // 上一次主题颜色
    collapse:false,  // 导航栏收缩状态
    menuRouteLoaded:false,    // 菜单和路由是否已经加载
    global:[]
  },
  getters: {
    collapse(state){// 对应着上面state
      return state.collapse
    }
  },
  mutations: {
    onCollapse(state){  // 改变收缩状态
      state.collapse = !state.collapse
    },
    setThemeColor(state, themeColor){  // 改变主题颜色
      state.themeColor = themeColor
    },
    setThemePath(state, themePath){  // 改变主题路径
      state.themePath = themePath
    },
    menuRouteLoaded(state, menuRouteLoaded){  // 改变菜单和路由的加载状态
      state.menuRouteLoaded = menuRouteLoaded;
    },
    setOptions(state, data){  // 设置字典数据
      state.global[data.key] = data.value
    },
  },
  actions: {
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js